import {ConsumableFormSchema} from '@/modules/products/consumables/schemas'
import {Consumable} from '@cypro/engine/schema'
import {SelectItem} from '@cypro/ui/components/form/select'

export function getConsumableFormDefaultValues(consumable: Consumable | undefined): ConsumableFormSchema {
  return {
    name: consumable?.name || '',
    description: consumable?.description || '',
    barcode: consumable?.barcode || '',
    nationalId: consumable?.nationalId || '',
    category: consumable?.category as ConsumableFormSchema['category'],
    unitsPerPackage: consumable?.unitsPerPackage || 0,
    minimumStock: consumable?.minimumStock || 0,
    machineId: '',
  }
}

export function mapConsumablesToSelectItems(consumables: Consumable[]): SelectItem[] {
  return consumables.map(item => ({label: item.name, value: item.id}))
}
